<template>
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer" v-if="langData">
        <span class="cursor-pointer flex items-center i18n-locale mr-4">
            <img class="h-4 w-5" :src="langData.flag" :alt="$i18n.locale"/>
            <span class="hidden sm:block ml-2">{{ langData.name }}</span>
        </span>
        <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
            <vs-dropdown-item class="i18n-item" v-for="l in lang" :key="l.name" @click="updateLocale(l.value)">
                <img :src="l.flag" alt="">
                <span>{{ l.name }}</span>
            </vs-dropdown-item>
        </vs-dropdown-menu>
    </vs-dropdown>
</template>

<script>
import languageJson from '@//app-languages.js'

export default {
    data() {
        return {
            langData: null
        }
    },

    computed: {
        lang() {
            return languageJson
        },

        user() {
            return this.$store.getters.userState
        }
    },

    watch: {
        '$i18n.locale'() {
            this.langData = this.lang[this.$i18n.locale]
        }
    },

    methods: {
        updateLocale(locale) {
            this.$i18n.locale = locale
        }
    },

    mounted() {
        if (this.user.locale){
            this.langData = this.lang[this.user.locale.toLowerCase()]
            this.$i18n.locale = this.user.locale.toLowerCase()
        }
    }
}
</script>

<style lang="scss">
.i18n-item {
    display: flex;
    align-items: center;

    img {
        width: 25px;
    }

    span {
        margin-left: 10px;
    }
}
</style>
